import { supabase } from "@/utils/supabase";
import { EmployeeMapper } from "@/adapters/Employee.mapper";
import { UserRole } from "@/types/employe/employee.common";
import { getRootStore } from "@/stores/RootStore";
export class TechnicianService {
    async getTechniciansWithParams(params) {
        try {
            let query = supabase()
                .from("employees")
                .select("*", { count: "exact" })
                .eq("isDeleted", false)
                .eq("role", "TECHNICIAN");
            // Фильтры
            if (params.filters) {
                const search = params.filters.search?.trim();
                if (search) {
                    const ors = [
                        `firstName.ilike.*${search}*`,
                        `lastName.ilike.*${search}*`,
                        `email.ilike.*${search}*`,
                        `phone.ilike.*${search}*`,
                    ];
                    query = query.or(ors.join(","));
                }
            }
            // Сортировка
            if (params.sorters && Object.keys(params.sorters).length > 0) {
                Object.entries(params.sorters).forEach(([field, order]) => {
                    if (order === "ascend")
                        query = query.order(field, { ascending: true });
                    else if (order === "descend")
                        query = query.order(field, { ascending: false });
                });
            }
            else {
                query = query.order("lastName", { ascending: true });
            }
            // Пагинация
            const from = (params.page - 1) * params.pageSize;
            query = query.range(from, from + params.pageSize - 1);
            const { data, error, count } = await query;
            if (error)
                throw error;
            return {
                data: data.map(EmployeeMapper.toDomain),
                total: count || 0,
                page: params.page,
                pageSize: params.pageSize,
            };
        }
        catch (error) {
            console.error("Error in getTechniciansWithParams:", error);
            throw error;
        }
    }
    async getTechniciansByIds(ids) {
        const { data, error } = await supabase()
            .from("employees")
            .select("*")
            .in("id", ids)
            .eq("role", "TECHNICIAN")
            .eq("isDeleted", false)
            .eq("isActive", true);
        if (error) {
            throw error;
        }
        return data.map(EmployeeMapper.toDomain);
    }
    async createTechnician(technicianData) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const technicianDto = EmployeeMapper.toCreateDto({
                ...technicianData,
                role: UserRole.TECHNICIAN,
                idCreatedBy: currentUserId,
            });
            const { data, error } = await supabase()
                .from("employees")
                .insert([technicianDto])
                .select()
                .single();
            if (error)
                throw error;
            return EmployeeMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error creating technician:", error);
            throw error;
        }
    }
    async updateTechnician(id, technicianData) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const technicianDto = EmployeeMapper.toCreateDto({
                ...technicianData,
                role: UserRole.TECHNICIAN,
                idUpdatedBy: currentUserId,
            });
            const { data, error } = await supabase()
                .from("employees")
                .update(technicianDto)
                .eq("id", id)
                .select()
                .single();
            if (error)
                throw error;
            return EmployeeMapper.toDomain(data);
        }
        catch (error) {
            console.error("Error updating technician:", error);
            throw error;
        }
    }
    async deleteTechnician(id) {
        try {
            const currentUserId = getRootStore().authStore.user?.id;
            const { error } = await supabase()
                .from("employees")
                .update({
                isDeleted: true,
                idUpdatedBy: currentUserId,
            })
                .eq("id", id);
            if (error)
                throw error;
        }
        catch (error) {
            console.error("Error deleting technician:", error);
            throw error;
        }
    }
}
export const technicianService = new TechnicianService();
